'use strict';

var _createForOfIteratorHelper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var internals = {};

module.exports = function (array1, array2) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!array1 || !array2) {
    return options.first ? null : [];
  }

  var common = [];
  var hash = Array.isArray(array1) ? new Set(array1) : array1;
  var found = new Set();

  var _iterator = _createForOfIteratorHelper(array2),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      if (internals.has(hash, value) && !found.has(value)) {
        if (options.first) {
          return value;
        }

        common.push(value);
        found.add(value);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return options.first ? null : common;
};

internals.has = function (ref, key) {
  if (typeof ref.has === 'function') {
    return ref.has(key);
  }

  return ref[key] !== undefined;
};